import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  onMounted, ref, getCurrentInstance, ComponentInternalInstance,
} from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'app-system-position-selector',
  props: {
  location: {
    type: Array,
    default: undefined,
  },
  address: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props



const instance = getCurrentInstance() as ComponentInternalInstance
const amap = ref<any>()
const dialog = ref<{ open:() => void; close: () => void }>()

onMounted(() => {
  dialog.value?.open()
})

const submitPosition = () => {
  instance.proxy?.$emit('position', {
    position: amap.value.centerPos,
    address: amap.value.searchText,
  })
}


return (_ctx: any,_cache: any) => {
  const _component_app_amap_layer_switcher = _resolveComponent("app-amap-layer-switcher")!
  const _component_app_amap_zoom = _resolveComponent("app-amap-zoom")!
  const _component_app_amap_location = _resolveComponent("app-amap-location")!
  const _component_app_amap = _resolveComponent("app-amap")!
  const _component_app_system_dialog = _resolveComponent("app-system-dialog")!

  return (_openBlock(), _createBlock(_component_app_system_dialog, {
    ref_key: "dialog",
    ref: dialog,
    title: '选择位置',
    width: 890,
    onClosed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closed'))),
    onSubmit: submitPosition
  }, {
    default: _withCtx(() => [
      _createVNode(_component_app_amap, { class: "map" }, {
        default: _withCtx(() => [
          _createVNode(_component_app_amap_layer_switcher),
          _createVNode(_component_app_amap_zoom),
          _createVNode(_component_app_amap_location, {
            location: __props.location,
            address: __props.address,
            ref_key: "amap",
            ref: amap
          }, null, 8, ["location", "address"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})